import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIBaseModule } from '@catui/ui-base.module';
import { DataTableModule } from 'primeng/primeng';
import { ProjectMediaSourcesComponent } from './components/project-media-sources/project-media-sources.component';
import {ProjectMediaSourcesService} from './services/project-media-sources.service';

@NgModule({
  imports: [
    CommonModule,
    UIBaseModule,
    DataTableModule,
  ],
  declarations: [ProjectMediaSourcesComponent],
  providers: [ProjectMediaSourcesService],
})
export class ProjectMediaSourcesModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/project-media-sources/project-media-sources.module.ts